<header>
<div class="icon-back" (click)="back()">
<mat-icon>arrow_back</mat-icon> 
</div>

<p class="header-tittle">Contanos sobre tu negocio</p>
</header>
<app-navigation [currentStep]="3" [countSteppers]="7"></app-navigation>

<form class="layout-form" [formGroup]="questionAndAnswersForm" (ngSubmit)="onSubmit()">
    <div class="component-content">
    <div class="header-text-container">
      <span class="header-text">Queremos conocer tu comercio. <br>
        Esto nos ayuda a ofrecerte lo mejor.</span>
    </div>
    <div class="scroll-display"> 
        <div *ngIf="questions">
            <div [@fadeInOut] class="form-select-content" [attr.data-testid]="'pregunta'+i" *ngFor="let question of questions; let i = index">
               <app-select-question *ngIf="i === questions.length - 1" [labelText]="question.description" [placeholder]="'Seleccionar'" [required]="true" [labelWarningGenericText] = "true"
                   [formControlName]="'questionId'+question.id" [submitted]="submitted" [options]="answers[i].answers">
                </app-select-question>
            </div>
            
        </div>
    </div>
    </div>

</form>